
import Vue from "vue";

export default Vue.extend({
  name: "main-footer",
  computed: {
    themeSwitchLabel(): string {
      let label: string = "";

      if (this.$vuetify.breakpoint.smAndUp) {
        label = this.$vuetify.theme.dark ? "Dark" : "Light";
      }
      return label;
    }
  }
});
